// proxyTable invalid with detail baseurl
// const target = `${window.location.host}`;
// var baseObj;
//
// switch (target) {
//   case 'hkgcfdv01779:8480':
//     baseObj = {
//       API_BASEURL: '//hkgcfdv01779:8580'
//     }
//     break;
//   case 'hln2199p:8480':
//     baseObj = {
//       API_BASEURL: '//hkgcfdv01758:8480'
//     }
//     break;
//   case 'hln2381p:8480':
//     baseObj = {
//       API_BASEURL: '//hkgcvdv80117:8843'
//     }
//     break;
//   case 'hklp706p:8480':
//     baseObj = {
//       API_BASEURL: '//hkgcvpd80078:8480'
//     }
//     break;
//   default:
//     baseObj = {
//       API_BASEURL: 'http://localhost:8484'
//     }
// }
//
// module.exports = baseObj;

// tigger proxyTable
export default () => `${window.location.protocol}//${window.location.host}`;



// WEBPACK FOOTER //
// ./src/utils/apiBaseUrlHelper.js